import React, { RefObject } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Entity } from "@common/types/entity";
import { EntityProvider } from "../entity/EntityProvider";
import { EntitySettings } from "./EntitySettings/EntitySettings";
import { EntitySettingsPages } from "./constants";
import { getEntityPaneKey } from "./lib";
import { SettingsTabPane } from "./SettingsTabPane";

interface Props {
    entity: Entity;
    scrollbars: RefObject<Scrollbars | null>;
}

export const EntityPanes: React.FC<Props> = ({ entity, scrollbars }) => (
    <EntityProvider entity={entity}>
        <SettingsTabPane
            eventKey={getEntityPaneKey(EntitySettingsPages.SETTINGS, entity.id)}
        >
            <EntitySettings scrollbars={scrollbars} />
        </SettingsTabPane>
    </EntityProvider>
);
